import { render } from "./TemplateMfittMyTicketChange.vue?vue&type=template&id=794d8162"
import script from "./TemplateMfittMyTicketChange.vue?vue&type=script&lang=js"
export * from "./TemplateMfittMyTicketChange.vue?vue&type=script&lang=js"
script.render = render

export default script